import styled from "styled-components";

export const AddEntityButtonStyled = styled.div`
  .plus-icon {
    font-size: 18px;
    margin-right: 4px;
  }
`;
